import React, { Component } from 'react';
import HotelLocations from 'components/widgets/autocompletes/hotelDestinations';
import FlightTravellers from 'components/widgets/flightTravellers';
import ErrorHandler from 'libraries/errorHandler';
import RangePicker from 'components/widgets/rangePickerNights';
import ErrorTooltip from 'components/snippets/errorTooltip';
import moment from 'moment';
import CustomRangePickerNights from 'components/widgets/customRangePickerNights';

class Addons extends Component {
    constructor(props) {
        super(props);

        const stateValue = {
            selectedDestination: null,
            depDate: null,
            retDate: null,
            numMonths: 2,
            shouldValidate: false,
            travellers: {
                adults: 1,
                children: [],
            },
            showTravellers: false,
            Traveltoken: props.Traveltoken,
            TravelRedirect: props.TravelRedirect,
        };

        const rules = {
            'form.destination': (destination) => {
                let valid = true;

                if (destination === null || Object.keys(destination).length === 0) {
                    valid = Lang.trans('engine_travelgenie.select_a_destination');
                }

                return valid;
            },
            'form.dates': (dates) => {
                let valid = true;
                if (dates.depDate === null || dates.retDate === null
                    || !moment(dates.depDate, 'MM/DD/YYYY', true).isValid()
                    || !moment(dates.retDate, 'MM/DD/YYYY', true).isValid()
                ) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }

                if (!moment(dates.retDate).isAfter(dates.depDate)
                    && moment(dates.depDate, 'MM/DD/YYYY', true).isValid()
                    && moment(dates.retDate, 'MM/DD/YYYY', true).isValid()) {
                    // valid = 'Return date should be greater than departure date';
                    valid = Lang.trans('error.invalid_dates');
                }
                return valid;
            },
            'travellers.childAge': (age, key, index) => {
                let valid = true;

                if (age === '') {
                    valid = `child ${index + 1} in room ${key + 1} needs an age`;
                }
                return valid;
            },
        };

        this.errorHandler = new ErrorHandler(rules);

        const storage = localStorage.getItem('hotelEngine');

        try {
            if (storage !== null && storage.length > 0) {
                Object.assign(stateValue, JSON.parse(storage));

                if (stateValue.depDate !== null) {
                    stateValue.depDate = moment(stateValue.depDate);
                    if (stateValue.depDate.isBefore(moment())) {
                        stateValue.depDate = moment();
                    }
                }

                if (stateValue.retDate !== null) {
                    stateValue.retDate = moment(stateValue.retDate);
                    if (stateValue.retDate.isBefore(moment())) {
                        stateValue.retDate = moment().add(1, 'day');
                    }
                }
            }
        } catch (e) {
            localStorage.removeItem('hotelEngine');
        }

        this.state = stateValue;

        this.toggleTravellers = this.toggleTravellers.bind(this);
        this.changeTravellers = this.changeTravellers.bind(this);
        this.handleTravellerBlur = this.handleTravellerBlur.bind(this);
        this.selectDestination = this.selectDestination.bind(this);
        this.onDatesChange = this.onDatesChange.bind(this);
        this.submit = this.submit.bind(this);

        this.onCustomDatesChange = this.onCustomDatesChange.bind(this);
        this.onCustomNightChange = this.onCustomNightChange.bind(this);
    }

    handleTravellerBlur(event) {
        let node = event.target;

        let within = false;

        while (node !== event.currentTarget) {
            node = node.parentNode;

            if (node.classList.contains('htl_popover')) {
                within = true;
                break;
            }
        }

        if (!within) {
            this.hideTravellers();
        }
    }

    toggleTravellers(occupancyOpen) {
        if (occupancyOpen) {
            this.showTravellers();
        } else {
            this.hideTravellers();
        }
    }

    hideTravellers() {
        const app = document.getElementById('app');
        app.removeEventListener('click', this.handleTravellerBlur);

        this.setState({ showTravellers: false });
    }

    showTravellers() {
        const app = document.getElementById('app');
        app.addEventListener('click', this.handleTravellerBlur);

        this.setState({ showTravellers: true });
    }

    changeTravellers(travellers) {
        this.setState({ travellers });
    }

    onDatesChange(depDate, retDate) {
        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.dates', { depDate, retDate });
        }
        this.setState({ depDate, retDate });
    }

    onCustomDatesChange(name, depDate) {

        const dateMonth = depDate.replace(/[0-9]/g, '').toLowerCase();
        let updatedDate = depDate;
        const { language } = app.dataset;

        if (language == 'fr') {
            let lowerCaseDate = depDate.toLowerCase();
            if (dateMonth == 'jan') {
                updatedDate =  lowerCaseDate.replace('jan', 'janv');
            } else if (dateMonth == 'fev') {
                updatedDate =  lowerCaseDate.replace('fev', 'févr.');
            } else if (dateMonth == 'mar') {
                updatedDate =  lowerCaseDate.replace('mar', 'mars');
            } else if (dateMonth == 'avr') {
                updatedDate =  lowerCaseDate.replace('avr', 'avr.');
            } else if (dateMonth == 'mai') {
                updatedDate =  lowerCaseDate.replace('mai', 'mai');
            } else if (dateMonth == 'jun') {
                updatedDate =  lowerCaseDate.replace('jun', 'juin');
            } else if (dateMonth == 'jul') {
                updatedDate =  lowerCaseDate.replace('jul', 'juil');
            }  else if (dateMonth == 'aou') {
                updatedDate =  lowerCaseDate.replace('aou', 'août');
            }  else if (dateMonth == 'sep') {
                updatedDate =  lowerCaseDate.replace('sep', 'sept');
            }  else if (dateMonth == 'oct') {
                updatedDate =  lowerCaseDate.replace('oct', 'oct.');
            }  else if (dateMonth == 'nov') {
                updatedDate =  lowerCaseDate.replace('nov', 'nov.');
            }  else if (dateMonth == 'dec') {
                updatedDate =  lowerCaseDate.replace('dec', 'déc.');
            }  
        }

        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.dates', { updatedDate });
            this.errorHandler.clear('form.dates');
        }
        updatedDate = moment(updatedDate, 'MM/DD/YYYY', true).isValid() ? moment(updatedDate) : updatedDate;
        this.setState({ [name]: updatedDate }, () => {
            const { depDate, retDate } = this.state;
            this.errorHandler.checkRule('form.dates', { depDate, retDate });
        });
    }

    onCustomNightChange(days) {
        const { shouldValidate } = this.state;
        const { depDate } = this.state;
        const retDate = moment(depDate, 'MM/DD/YYYY').add(days, 'days');

        this.setState({ retDate });
    }

    selectDestination(selectedDestination) {
        const { shouldValidate } = this.state;
        if (shouldValidate) {
            this.errorHandler.checkRule('form.destination', selectedDestination);
        }
        this.setState({ selectedDestination });
    }

    submit(event) {
        const {
            selectedDestination,
            depDate,
            retDate,
            travellers,
            showTravellers,
            Traveltoken,
            TravelRedirect,
        } = this.state;

        this.errorHandler.checkRule('form.destination', selectedDestination);
        this.errorHandler.checkRule('form.dates', { depDate, retDate });

        const errors = this.errorHandler.getErrors();

        if (Object.keys(errors).length > 0) {
            event.preventDefault();
            this.setState({ shouldValidate: true });
        } else {
            event.preventDefault();

            const bundles = {};
            const params = {};

            selectedDestination.radius = 10;
            params.occupancy = travellers;
            params.depDate = depDate !== null ? depDate.format('YYYY-MM-DD') : '',
            params.retDate = retDate !== null ? retDate.format('YYYY-MM-DD') : '',
            params.destination = selectedDestination;
            params.showTravellers = showTravellers;

            params.selectedProducts = 'A';

            bundles.bundles = [{ ...params }];

            // bundles.refundable = "1";
            bundles.lang = window.Locale;
            bundles.currency = 'USD';
            bundles.affiliate = 'redtag';

            const queryString = JSON.stringify(bundles);
            const encodeUrl = encodeURI(queryString);
            // console.log('queryString',queryString);
            // console.log('encodeUrl', encodeUrl);
            const url = `${TravelRedirect}/create?t=${Traveltoken}&request=${encodeUrl}`;
            window.location.href = url;

            const storage = {
                selectedDestination,
                depDate,
                retDate,
                travellers,
                showTravellers,
            };

            localStorage.setItem('hotelEngine', JSON.stringify(storage));

            // const url = TravelRedirect+"/?t=" + Traveltoken;
            // window.location.href = url;
        }
    }

    render() {
        const {
            selectedDestination,
            depDate,
            retDate,
            numMonths,
            travellers,
            showTravellers,
        } = this.state;

        const errors = this.errorHandler.getErrors();

        const isDepDatevalid = moment(depDate, 'MM/DD/YYYY', true).isValid();
        const isRetDatevalid = moment(retDate, 'MM/DD/YYYY', true).isValid();

        const request = {
            depDate: (depDate !== null && moment(depDate, 'MM/DD/YYYY', true).isValid()) ? depDate.format('YYYY-MM-DD') : '',
            retDate: (retDate !== null && moment(retDate, 'MM/DD/YYYY', true).isValid()) ? retDate.format('YYYY-MM-DD') : '',
            destination: selectedDestination,
            selectedProducts: 'H',
            lang: 'en',
        };

        return (
            <form className="search-add-ons pt-1" action="" onSubmit={this.submit}>
                <input type="hidden" name="request" value={JSON.stringify(request)} />
                <div className="row gutter-10 mb-md-2">
                    <div className="col-12 col-md-12 col-lg-7 departing-from">
                        <div className="element-container">
                            <label className="text-label" htmlFor="addons_destination">Going to</label>
                            <div className="element-wrapper">
                                <HotelLocations
                                    id="addons_destination"
                                    placeholder="Select a location"
                                    onSelect={this.selectDestination}
                                    value={selectedDestination}
                                />
                                {errors.form && errors.form.destination && (
                                    <ErrorTooltip error={{ message: errors.form.destination, id: 'destination' }} />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-5 duration">
                        <div className="element-container range-picker-container">
                            {/* <RangePicker
                                startDateId="dyn_departureDate"
                                endDateId="dyn_returnDate"
                                onDatesChange={this.onDatesChange}
                                minDate={2}
                                startDatePlaceholderText="Start Date"
                                endDatePlaceholderText="End Date"
                                startDate={depDate}
                                endDate={retDate}
                                numberOfMonths={numMonths}
                            /> */}
                            <CustomRangePickerNights
                                startDateId="dyn_departureDate"
                                endDateId="dyn_returnDate"
                                onDatesChange={this.onDatesChange}
                                onCustomDatesChange={this.onCustomDatesChange}
                                onCustomNightChange={this.onCustomNightChange}
                                minDate={2}
                                startDatePlaceholderText="mm/dd/yyyy"
                                endDatePlaceholderText="mm/dd/yyyy"
                                startDate={depDate}
                                endDate={retDate}
                                isDepDatevalid={isDepDatevalid}
                                isRetDatevalid={isRetDatevalid}
                                numberOfMonths={numMonths}
                            />
                            {errors.form && errors.form.dates && (
                                <ErrorTooltip error={{ message: errors.form.dates, id: 'dates' }} />
                            )}
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 room-guest">
                        <div className="element-container mb-lg-0">
                            <FlightTravellers
                                travellers={travellers}
                                onChange={this.changeTravellers}
                                errors={errors.travellers}
                                visible={showTravellers}
                                onVisibilityChange={this.toggleTravellers}
                            />
                        </div>
                    </div>
                </div>
                <div className="row gutter-10 border-top pt-2 align-items-end">
                    <div className="col-12 col-md-12 col-xl-4 col-lg-6 text-lg-center my-2 offset-xl-4 d-md-flex mb-2 mb-lg-0 mt-2">
                        <input name="" id="" className="col-12 col-sm-6 bg-white font-weight-500 py-3 border" placeholder="Promo Code" />
                        <button type="submit" className="btn btn-primary btn-lg px-5 ml-md-3 mt-2 mt-sm-0 text-white">
                            <span className="">Search</span>
                        </button>
                    </div>
                    {/* <div className="col-12 col-md-12 col-lg-4 text-xl-right my-2">
                        <a type="" className="col-6 col-md-5 text-underline">
                            <span className="">Advanced Search</span>
                        </a>
                        <a type="" className="col-6 col-md-6 text-underline">
                            <span className="">Multiple Destinations</span>
                        </a>
                    </div> */}
                </div>
            </form>
        );
    }
}

export default Addons;
